import react, { useContext, useEffect, useState } from 'react';
import { Modal,styled } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import veriuser from "./../../../../assets/images/Group 5276.png"
import { getCaller } from '../../../../services/api';
import { generateImageURL, showDob } from '../../../../utils';
import GlobalContext from '../../../../context/GlobalContext';
import { useTranslation } from 'react-i18next';


function DoctorViewModal({
    openDialog,
    setOpenDialog,
    doctorId


}) {

    const handleClose = () => {
        setOpenDialog(false);
    }
    const context = useContext(GlobalContext);
    const [, setUserProfile] = context.userProfile;
    const { t } = useTranslation();

    const [doctorView, setDoctorView] = useState({});


    const fetchDoctorDetails = async () => {
        const response = await getCaller(`public/profile/doctor/${doctorId}`)
        console.log("🚀 ~ file: DoctorViewModal.jsx:26 ~ fetchDoctorDetails ~ response", response)
        setDoctorView(response?.data)
    }



    useEffect(() => {
        fetchDoctorDetails();
    }, [])

    function capitalize(s) {
        return s && s[0].toUpperCase() + s.slice(1);
    }
    return (
        <>
            <Modal
                open={openDialog}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <StyledBox>
                    <Box sx={{ flexGrow: 1, marginTop: 5, paddingBottom: 10 }}>
                        <Grid container>
                            <Grid item xs={14} md={14} className="side-right-content">
                                <div className='side-right-head'>
                                    <h2 style={{
                                        textTransform: 'capitalize'
                                    }}> Doctor Profile View</h2>
                                </div>
                                <Grid item xs={12} md={12}>
                                    <div className="doctor-profile-view-modal">
                                        <div className="profile-img">
                                            <img
                                                src={generateImageURL(doctorView?.profile?.url ?? "Doctor Profile")}
                                                alt=""
                                                width="175"
                                                style={{ borderRadius: "8px" }}
                                            />

                                            <br />
                                        </div>
                                        <div className="profile-content">
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <h3>{doctorView?.profile?.name ?? "Doctor"} </h3>{" "}
                                                <img src={veriuser} alt="" style={{ marginLeft: "1rem" }} />
                                            </div>
                                            <h4> { } </h4>
                                            <Box sx={{ flexGrow: 1, marginTop: 2 }}>
                                                <Grid
                                                    container
                                                    spacing={{ xs: 2, md: 3 }}
                                                    columns={{ xs: 4, sm: 8, md: 12 }}
                                                >
                                                    <Grid item xs={12} sm={4} md={4}>
                                                        <p> {t("mobileNumber")} </p>
                                                        <h5>{doctorView?.profile?.mobile ?? "Not available"} </h5>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4} md={4}>
                                                        <p> {t("emailId")} </p>
                                                        <h5>{doctorView?.profile?.email ?? "Not available"} </h5>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4} md={4}>
                                                        <p> {t("gender")} </p>
                                                        <h5>{capitalize(doctorView?.profile?.gender) ?? "Not available"}</h5>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4} md={4}>
                                                        <p> {t("location")} </p>
                                                        <h5> {doctorView?.profile?.location ?? "Not available"} </h5>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4} md={4}>
                                                        <p> {t("dob")} </p>
                                                        <h5> {`${showDob(doctorView?.profile?.dob)}` ?? "Not available"} </h5>
                                                    </Grid>

                                                    <Grid item xs={12} sm={4} md={4}>
                                                        <p> {t("age")} </p>
                                                        <h5> {doctorView?.profile?.age ?? "Not available"} </h5>
                                                    </Grid>

                                                    <Grid item xs={12} sm={4} md={4}>
                                                        <p> Years Of Experience </p>
                                                        <h5> {doctorView?.profile?.experience ?? "Not available"} </h5>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4} md={4}>
                                                        <p> {t("appointmentFees")} </p>
                                                        <h5> {doctorView?.profile?.fees ?? "Not available"} </h5>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4} md={4}>
                                                        <p> License </p>
                                                        <h5> Not available </h5>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4} md={4}>
                                                        <p> Review </p>
                                                        <h5> {Number(doctorView?.profile?.reviews).toPrecision(2) ?? "Not available"} </h5>
                                                    </Grid>
                                                    <Grid item xs={12} sm={4} md={4}>
                                                        <p> About </p>
                                                        <h5>{doctorView?.profile?.description ?? "Not available"}</h5>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </StyledBox>
            </Modal>
        </>
    )
}
const StyledBox = styled(Box)(
    ({ theme }) => ({
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 900,
        height: "100%",
        maxHeight: 600,
        overflow: "hidden",
        borderRadius: "1rem",
        bgcolor: 'white',
        display: "block",
        backgroundColor: 'white',
        [theme.breakpoints.down('md')]: {
            width: '90%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '90%',
        }
    })
)
export default DoctorViewModal



